export default "__VITE_ASSET__ALTXHNA2__"